import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="mb-8"><Logo size="lg" /></div>
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-display">Recuperar senha</CardTitle>
          <CardDescription>Enviaremos um link de redefinição para seu e-mail.</CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4" data-testid="forgot-success">
              <p className="text-sm text-slate-600">
                Se o e-mail estiver cadastrado, você receberá as instruções de recuperação na sua caixa de entrada
                (verifique também o spam). O link expira em 1 hora.
              </p>
              <Link to="/login">
                <Button className="w-full h-12 bg-sky-600 hover:bg-sky-700 text-white" data-testid="back-login-btn">Voltar ao login</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">E-mail cadastrado</Label>
                <Input id="email" data-testid="forgot-email" type="email" required className="h-12"
                       value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@empresa.com.br" />
              </div>
              <Button type="submit" className="w-full h-12 bg-sky-600 hover:bg-sky-700 text-white" disabled={loading} data-testid="forgot-submit-btn">
                {loading ? "Enviando..." : "Enviar link de recuperação"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
      <Link to="/login" className="mt-6 text-sm text-slate-500 hover:text-slate-800" data-testid="back-login-link">← Voltar ao login</Link>
    </div>
  );
}
